import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { SERVICES, HOME } from '../content/site';
import { PageHeader } from '../components/blocks/PageHeader';
import { ServiceGrid } from '../components/blocks/ServiceGrid';
import { ProcessSteps } from '../components/blocks/ProcessSteps';
import { Section, SectionHeading, Reveal, ButtonLink } from '../components/ui/Primitives';
export function ServicesPage() {
  const {
    language
  } = useLanguage();
  const t = SERVICES[language];
  const home = HOME[language];
  return <>
      <PageHeader eyebrow={t.eyebrow} title={t.title} sub={t.subtitle} data-id="element-363" data-mp="2g7v7ufgh7cbh" />

      <Section tone="cream" data-id="element-364" data-mp="2l1pmh4h8513p">
        <ServiceGrid data-id="element-365" data-mp="2l2hi2fatmytz" />
        <Reveal delay={0.1} data-id="element-366" data-mp="2pzhm6ko41rig">
          <p className="mt-8 max-w-2xl text-xs font-light leading-relaxed text-espresso/45" data-id="element-367" data-mp="2pzr73tuat8ha">
            {t.note}
          </p>
        </Reveal>
      </Section>

      <Section tone="white" data-id="element-368" data-mp="2uwrd64r5eb8e">
        <SectionHeading eyebrow={home.processTeaser.eyebrow} title={home.processTeaser.headline} className="mb-14" data-id="element-369" data-mp="2zwvsvsk8f1xk" />
        <ProcessSteps data-id="element-370" data-mp="2xhy84jmtjhsv" />
        <Reveal delay={0.15} data-id="element-371" data-mp="2sl7s1wb0km7g">
          <div className="mt-14" data-id="element-372" data-mp="2sjwonxlhdggv">
            <ButtonLink to="/contact" data-id="element-373" data-mp="2sjn08eg33hda">{home.contactTeaser.cta}</ButtonLink>
          </div>
        </Reveal>
      </Section>
    </>;
}